import React, { useEffect, useRef, useState } from 'react';
import './BrowserTop.css';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as AddTokenGatedSVG } from '../Images/buttons/addTokenGatedButton.svg';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { ReactComponent as TokenLockSVG } from '../Images/buttons/tokenLockButton.svg';
import AddAccess from '../Util/AddAccess';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, isAuthLoadedAtom, topMessageAtom, myNftAtom } from '../../State';
import AddTokenGated from './AddTokenGated';
import DataModel from '../Util/DataModel';
import CheckLive from './CheckLive';
import Loading from '../Loading/Loading';
import isElectron from '../../Global';
import KUTE from 'kute.js';

export default function AddLive({
  setShowLive,
  roomID,
  showLiveState,
  setShowLiveState,
  setRoomID,
  callReload,
}) {
  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const { t } = useTranslation();

  //その他
  const [startDate, setStartDate] = useState(new Date());
  const [titleState, setTitleState] = useState('');
  const [roomIDState, setRoomIDState] = useState(null);
  const [tempTitleState, setTempTitleState] = useState('');
  const newTitle = useRef(null);
  const [formState, setFormState] = useState('detail');
  const [isSending, setIsSending] = useState(false);
  const [gatedData, setGatedData] = useState({});
  const [isLoadingState, setIsLoadingState] = useState(
    showLiveState == 'edit' || showLiveState == 'editMeeting' ? true : false,
  );
  const titleRef = useRef(null);
  const [isMeeting, setIsMeeting] = useState(false);
  const [titleError, setTitleError] = useState(false);

  useEffect(() => {
    //console.log(new Date('2022-12-28T22:30:00.000Z'));
    //const result = format(startDate, 'MM/dd/yyyy');
  }, [startDate]);

  useEffect(() => {
    let kute = KUTE.to(
      '#liveAddWrap',
      { top: '15%', opacity: 1 },
      {
        duration: 200,
        easing: 'easingCubicOut',
        onComplete: () => {},
      },
    );
    kute.start();
  }, []);

  useEffect(() => {
    if (showLiveState == 'newMeeting' || showLiveState == 'editMeeting') {
      setIsMeeting(true);
    }

    if (showLiveState == 'edit' || showLiveState == 'editMeeting') {
      getData();
    }
  }, []);

  //既存情報取得
  async function getData() {
    //編集の場合はデータを読み込む
    setIsLoadingState(true);

    //ルーム情報取得
    let roomInfo;
    roomInfo = await DataModel.checkRoom(roomID, true, null);

    //ルームが存在しない場合
    if (roomInfo.dailyRoomURL == null) {
      alert(t('mypage.URL is not valid. No room exist'));
    }
    //ルームが存在する場合
    else {
      //タイトル
      setTitleState(roomInfo.liveData?.liveTitle);

      //日時
      let date = new Date(roomInfo.liveData?.liveDate?._seconds * 1000);
      setStartDate(date);

      //ミーティングトークン
      //setMeetingTokenState(roomInfo.meetingToken);
    }

    setIsLoadingState(false);
  }

  const handleChange = (e) => {
    setTitleState(e.target.value);
  };

  //保存ボタンを押した時
  const clickSave = async () => {
    if (isSending) {
      return;
    }

    //空欄チェック
    if (titleState == '' || titleState == null) {
      setTitleError(true);
      return;
    } else {
      setTitleError(false);
    }

    setIsSending(true);

    //DBに保存
    const result = await DataModel.editLive(
      showLiveState == 'edit' || showLiveState == 'editMeeting' ? roomID : null, //ルームID
      titleState,
      startDate,
      Intl.DateTimeFormat().resolvedOptions().timeZone, //タイムゾーン
      myNftState,
      gatedData,
      showLiveState == 'edit' || showLiveState == 'editMeeting' ? 'edit' : 'new', //新規か編集か
      isMeeting,
    );

    if (result != null) {
      //リストをリロード
      callReload();

      if (showLiveState == 'new') {
        console.log(result);
        setRoomID(result.meetingID);

        setShowLiveState('detail');

        setTopMessageState({
          type: 'joined',
          message: t('mypage.Added!'),
        });
      }

      if (showLiveState == 'edit') {
        setRoomID(roomID);
        setShowLiveState(null);

        setTopMessageState({
          type: 'joined',
          message: t('mypage.Saved!'),
        });
      }

      if (showLiveState == 'newMeeting') {
        callReload();
        setShowLiveState(null);

        setTopMessageState({
          type: 'joined',
          message: t('mypage.Added!'),
        });
      }

      if (showLiveState == 'editMeeting') {
        callReload();
        setShowLiveState(null);
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Saved!'),
        });
      }
    }
    //エラーの場合
    else {
      alert(t('mypage.Error, please try again'));
    }

    setIsSending(false);
  };

  //削除ボタン
  const clickDelete = async () => {
    setGatedData({});
  };

  var component = (
    <>
      <div className="addAreaBack"></div>
      <div id="liveAddWrap">
        <div className="electronTop">
          {/*ローディング中*/}
          <div className="isElectron">
            <Loading loadingState={isLoadingState} />
          </div>
          <>
            <div className="electronInputHeader" style={{ marginBottom: '15px' }}>
              <div className="electronTitle">
                {isMeeting ? t('mypage.New meeting') : t('mypage.Start your live')}
              </div>
              <div className="electronHeaderSetting" onClick={() => setShowLiveState(null)}>
                <CloseSVG />
              </div>
            </div>

            <div className="electronDetailExplanation">
              {isMeeting ? t('mypage.Meeting detail...') : t('mypage.You can invite...')}
            </div>

            <div className="electronInputWrap">
              <div className="electronInputTitleWrap">
                <div className="electronInputTitle">
                  {isMeeting ? t('mypage.Meeting title') : t('mypage.Title of your Live')}
                </div>
              </div>
              <input
                className="electronInput"
                name="titlename"
                type="text"
                autoFocus={true}
                placeholder={isMeeting ? t('mypage.Enter title') : t('mypage.Enter Live Title')}
                onChange={(e) => handleChange(e)}
                value={titleState}
              />
              {titleError && <div className="titleError">{t('mypage.Title cannot be blank')}</div>}
            </div>

            <div className="electronInputWrap">
              <div className="electronInputTitleWrap">
                <div className="electronInputTitle">{t('mypage.Date and time')}</div>
              </div>

              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                dateFormat="MM/d/yyyy h:mm aa"
                minDate={new Date()}
              />
              <div className="timezone">
                {t('mypage.Time zone') + ':' + Intl.DateTimeFormat().resolvedOptions().timeZone}
              </div>
            </div>

            {/* <div className="electronInputWrap">
            <div className="electronInputTitleWrap">
              <div className="electronInputTitle">{t('mypage.Token-gated')}</div>
            </div>

            {gatedData.tokenGatedType != null && (
              <div className="electronTokenOpenseaWrap">
                <div>
                  {gatedData.collectionImageURL == null ? (
                    <TokenLockSVG />
                  ) : (
                    <img src={gatedData.collectionImageURL} />
                  )}
                </div>
                <div className="electronTokenOpenseaDetail">
                  <div className="electronTokenOpenseaBody">
                    {t('mypage.Only holders can access')}
                  </div>

                  {gatedData.ercType != null && gatedData.ercType != 'ERC721'
                    ? gatedData.contractAddress
                    : gatedData.collectionName}
                </div>
                <div className="electronTokenOpenseaDelete" onClick={clickDelete}>
                  {t('mypage.delete')}
                </div>
              </div>
            )}

            {gatedData.tokenGatedType == null && (
              <div
                className="electronAddTokenWrap"
                onClick={() => {
                  setFormState('addTokenGated');
                }}>
                <div className="electronAddSVG">
                  <AddTokenGatedSVG />
                </div>
                {t('mypage.Add token-gated')}
              </div>
            )}
          </div> */}

            <div className="electronInputButtonWrap">
              <button onClick={clickSave} className="topIDITem" id="newMeetingButton">
                {!isSending ? (
                  <div className="topIDName">{t('mypage.Save')}</div>
                ) : (
                  <>
                    <div className="selectLoader">
                      <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                          className="loader-path"
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          stroke="#70c542"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                  </>
                )}
              </button>
            </div>
          </>
        </div>
      </div>
    </>
  );

  if (isElectron) {
    return (
      <>
        <div class="isElectron">{component}</div>
      </>
    );
  } else {
    return <>{component}</>;
  }
}
